/* ───────────────────────────────────────────────────────────────
   Agent Console — single <Icon> component (ported from the design
   handoff ac-data.jsx). Stroked, currentColor, 24×24 viewBox. Paths
   are static constants (no user input) so dangerouslySetInnerHTML is
   safe here — it lets us keep the exact design path data verbatim.
   ─────────────────────────────────────────────────────────────── */
import React from 'react';

export const ICON_PATHS: Record<string, string> = {
  myday: '<path d="M12 3v2M5.6 5.6l1.4 1.4M3 12h2M19 12h2M17 7l1.4-1.4M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM7 17h10l-1 4H8l-1-4z"/>',
  chat: '<path d="M4 5.5A1.5 1.5 0 0 1 5.5 4h13A1.5 1.5 0 0 1 20 5.5v9a1.5 1.5 0 0 1-1.5 1.5H10l-4 3.5V16H5.5A1.5 1.5 0 0 1 4 14.5v-9z"/>',
  queue: '<path d="M4 7h16M4 12h16M4 17h10"/>',
  team: '<path d="M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM2.5 19a5.5 5.5 0 0 1 11 0M16 11a3 3 0 1 0 0-6M21.5 19a5.5 5.5 0 0 0-5-5.47"/>',
  search: '<circle cx="11" cy="11" r="6.5"/><path d="M16 16l4 4"/>',
  bell: '<path d="M6 9a6 6 0 1 1 12 0c0 5 2 6 2 6H4s2-1 2-6zM9.5 20a2.5 2.5 0 0 0 5 0"/>',
  sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4 12H2M22 12h-2M5.6 5.6 4.2 4.2M19.8 19.8l-1.4-1.4M18.4 5.6l1.4-1.4M4.2 19.8l1.4-1.4"/>',
  moon: '<path d="M20 14.5A8 8 0 0 1 9.5 4 8 8 0 1 0 20 14.5z"/>',
  globe: '<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c2.5 2.5 2.5 15 0 18M12 3c-2.5 2.5-2.5 15 0 18"/>',
  chevron: '<path d="M9 6l6 6-6 6"/>',
  send: '<path d="M4 11.5 19 5l-4.5 14.5-3-6.5-6.5-1.5z"/>',
  clip: '<path d="M18 8.5 10.2 16.3a2.4 2.4 0 0 1-3.4-3.4l8-8a4 4 0 0 1 5.6 5.6l-8.5 8.5a5.6 5.6 0 0 1-7.9-7.9l7.4-7.4"/>',
  lock: '<path d="M5 11h14v10H5z"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>',
  bot: '<rect x="5" y="8" width="14" height="11" rx="3"/><path d="M12 4v4M9 13h.01M15 13h.01M2.5 12.5v2M21.5 12.5v2"/>',
  sparkle: '<path d="M12 3l1.8 4.7L18.5 9l-4.7 1.3L12 15l-1.8-4.7L5.5 9l4.7-1.3L12 3zM18.5 14l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8.8-2z"/>',
  user: '<circle cx="12" cy="8" r="4"/><path d="M4.5 20a7.5 7.5 0 0 1 15 0"/>',
  takeover: '<path d="M8 13V5.5a1.5 1.5 0 0 1 3 0V11m0-1.5a1.5 1.5 0 0 1 3 0V11m0-1a1.5 1.5 0 0 1 3 0v4.5a5.5 5.5 0 0 1-5.5 5.5H11a4 4 0 0 1-3-1.8L5 17"/>',
  release: '<path d="M4 12a8 8 0 0 1 13.7-5.6L20 8M20 4v4h-4"/>',
  check: '<path d="M5 12.5 10 17.5 19 7"/>',
  checkdouble: '<path d="M2 12.5 6 16.5 13 8M11 16l1 1 7-9"/>',
  clock: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>',
  mail: '<rect x="3" y="5" width="18" height="14" rx="2.5"/><path d="M4 7l8 5.5L20 7"/>',
  msgcircle: '<path d="M4 12a8 8 0 1 1 3.5 6.6L4 20l1.2-3.4A7.9 7.9 0 0 1 4 12z"/>',
  whatsapp: '<path d="M4 12a8 8 0 1 1 3.5 6.6L4 20l1.5-3.4A7.9 7.9 0 0 1 4 12z"/><path d="M9.5 9c0 4 2 5.5 4.5 6 .8-.2 1.3-.8 1.5-1.5l-1.8-1-1 .8c-1-.5-1.8-1.3-2.2-2.3l.8-.9-.9-1.8c-.4.1-.9.4-.9.9z" fill="currentColor" stroke="none"/>',
  messenger: '<path d="M12 3.5c-4.7 0-8.5 3.5-8.5 7.9 0 2.5 1.2 4.7 3.1 6.1V21l2.8-1.5c.8.2 1.7.3 2.6.3 4.7 0 8.5-3.5 8.5-7.9S16.7 3.5 12 3.5z"/><path d="M6.8 14.3 11 10l2.3 2.2L16.8 10l-4 4.3-2.3-2.1-3.7 2.1z" fill="currentColor" stroke="none"/>',
  dots: '<circle cx="5" cy="12" r="1.6"/><circle cx="12" cy="12" r="1.6"/><circle cx="19" cy="12" r="1.6"/>',
  x: '<path d="M6 6l12 12M18 6 6 18"/>',
  arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>',
  building: '<rect x="5" y="3" width="14" height="18" rx="1.5"/><path d="M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2"/>',
  pin: '<path d="M12 21s7-5.7 7-11a7 7 0 1 0-14 0c0 5.3 7 11 7 11z"/><circle cx="12" cy="10" r="2.5"/>',
  tag: '<path d="M3 12.5 11 4.5h6.5V11l-8 8L3 12.5z"/><circle cx="14.5" cy="7.5" r="1.3"/>',
  trend: '<path d="M3 17l5-5 4 3 6-7M16 8h4v4"/>',
  alert: '<path d="M12 4 22 19H2L12 4zM12 10v4M12 17h.01"/>',
  cart: '<path d="M3 4h2l2 12h11l2-8H6M9 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM17 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>',
  star: '<path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 17.9 6.8 19.6l1-5.8L3.5 9.7l5.9-.9L12 3.5z"/>',
  filter: '<path d="M4 6h16M7 12h10M10 18h4"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  phone: '<path d="M5 4h3l1.5 5L7 11a11 11 0 0 0 6 6l2-2.5 5 1.5V19a2 2 0 0 1-2 2A16 16 0 0 1 4 6a2 2 0 0 1 1-2z"/>',
  logout: '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/>',
  flag: '<path d="M5 21V4M5 4h12l-2 4 2 4H5"/>',
  cog: '<circle cx="12" cy="12" r="3"/><path d="M12 2.5l1.2 2.3 2.5-.6.6 2.5 2.3 1.2-1.3 2.2 1.3 2.2-2.3 1.2-.6 2.5-2.5-.6L12 21.5l-1.2-2.3-2.5.6-.6-2.5-2.3-1.2 1.3-2.2-1.3-2.2 2.3-1.2.6-2.5 2.5.6L12 2.5z"/>',
  book: '<path d="M4 5.5A1.5 1.5 0 0 1 5.5 4H19v14H5.5A1.5 1.5 0 0 0 4 19.5v-14zM4 19.5A1.5 1.5 0 0 0 5.5 21H19v-3"/>',
  // OP-1005 — "no entry" mark for the Spam / unwanted action and the Marked-as-spam view.
  ban: '<circle cx="12" cy="12" r="8.5"/><path d="M6 6l12 12"/>',
  // Console v2 (C1-5) - ported from the approved prototype's Icon.tsx (stroke geometry only; the prototype's
  // `lock`, `bot`, `user`, `tag`, `check`, `clock`, ... already exist above under the console's own paths).
  lifebuoy: '<path d="M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0"/><path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0"/><path d="m4.93 4.93 4.24 4.24"/><path d="m14.83 9.17 4.24-4.24"/><path d="m14.83 14.83 4.24 4.24"/><path d="m9.17 14.83-4.24 4.24"/>',
  hand: '<path d="M18 11V6a2 2 0 0 0-4 0v5"/><path d="M14 10V4a2 2 0 0 0-4 0v6"/><path d="M10 10.5V6a2 2 0 0 0-4 0v8"/><path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"/>',
  undo: '<path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/>',
  question: '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/><path d="M9.5 8.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .8-1 1.5"/><path d="M12 14.5h.01"/>',
  inbox: '<path d="M22 12h-6l-2 3h-4l-2-3H2"/><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>',
  users: '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><path d="M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>',
  shield: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>',
  folder: '<path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2z"/>',
  eye: '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><path d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>',
  reply: '<path d="m9 17-5-5 5-5"/><path d="M20 18v-2a4 4 0 0 0-4-4H4"/>',
  loader: '<path d="M21 12a9 9 0 1 1-6.22-8.56"/>',
  pencil: '<path d="M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5z"/>',
  chevronStart: '<path d="m15 18-6-6 6-6"/>',
  chevronEnd: '<path d="m9 18 6-6-6-6"/>',
  panelLeft: '<path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/><path d="M9 3v18"/>',
  panelRight: '<path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/><path d="M15 3v18"/>',
};

export type IconName = keyof typeof ICON_PATHS;

export interface IconProps {
  name: string;
  size?: number;
  stroke?: number;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

/**
 * Icons that point "forwards / backwards" and must mirror in right-to-left. chevronStart / chevronEnd are named
 * for the INLINE direction, so in LTR they are drawn as-is and in RTL the `.flip-rtl` rule (agent-console.css)
 * mirrors them; panelLeft / panelRight and the reply arrows are drawn physically and mirror the same way.
 */
export const DIRECTIONAL_ICONS: readonly string[] = ['chevronStart', 'chevronEnd', 'reply', 'undo', 'panelLeft', 'panelRight'];

export function Icon({ name, size = 20, stroke = 2, className = '', style = {}, title }: IconProps) {
  const cls = DIRECTIONAL_ICONS.includes(name) ? `${className} flip-rtl`.trim() : className;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cls}
      style={style}
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      dangerouslySetInnerHTML={{ __html: (title ? `<title>${title}</title>` : '') + (ICON_PATHS[name] || '') }}
    />
  );
}

/** Channel → icon name. Superset of the design + backend channels. */
export const CHANNEL_ICON: Record<string, string> = {
  web: 'msgcircle',
  email: 'mail',
  whatsapp: 'whatsapp',
  messenger: 'messenger',
  sms: 'phone',
};

/** Channel → brand colour for the small channel dot. */
export const CHANNEL_COLOR: Record<string, string> = {
  web: '#1E6BD8',
  email: '#E8923B',
  whatsapp: '#16A86B',
  messenger: '#8B5CF6',
  sms: '#0E9AA0',
};

export function channelIconName(channel: string): string {
  return CHANNEL_ICON[(channel || '').toLowerCase()] || 'msgcircle';
}
export function channelColor(channel: string): string {
  return CHANNEL_COLOR[(channel || '').toLowerCase()] || '#5B6B82';
}
